import { Tooltip } from "antd";

/**
 * High-contrast badge surfaced on any section whose classification is
 * `clinician_controlled`. Not dismissible. Mirrors the data-layer
 * enforcement: the section library forbids AI on these sections, the
 * backend validator rejects bad saves, this badge signals to the admin.
 *
 * Wording is intentionally generic ("Clinician only") pending Ashish's
 * decision on the preferred wording. See open question in
 * docs/spec/display-template-builder.md.
 */
export default function AIOffBadge({ label = "Clinician only", tooltip }) {
  const badge = (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-700 border border-red-300"
      aria-label="This section is clinician-controlled. AI will not write here."
    >
      <span className="text-base leading-none" aria-hidden>🔒</span>
      <span>{label}</span>
    </span>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{badge}</Tooltip>;
  }
  return badge;
}
